module.exports = __webpack_public_path__ + "img/wizard-tsort-1.8e10ba4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/setting-wizard/wizard-tsort-1.svg
// module id = 5HpQ
// module chunks = 1